import AuthSerivce from '@/@http/auth/auth.service' // get token from cookie

const whiteList = ['/auth'] // no redirect whitelist

export default (to: any, from: any, next: any) => {
    const authSerivce = new AuthSerivce();
    const hasToken = authSerivce.getToken();
    const wd: any = window;
    if (hasToken && wd.loadRouters) {
        return next();
    }
    if (hasToken && !wd.loadRouters) {
            authSerivce.refresh().then((rs) => {
                if (rs && rs.userInfo.enable) {
                    return next();
                }
                localStorage.clear();
                return next(`/auth/login`);
            });
    } else {
        return next(`/auth/login`);
    }
    // return next();
};
